module.exports = __webpack_public_path__ + "img/derek-pro.27459960.jpg";